import "../App.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import MarcNavbar from "../components/Navbar";
import MarcFooter from "../components/Footer";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Album from "../components/Album";
import shp from "../assets/shp.jpeg";
import bard1 from "../assets/DND+NRS+Album+Cover.png";
import bard2 from "../assets/DND+ELM+Album+Cover.jpeg";
import stalling from "../assets/STL+Album+Cover.png";
import missingTwin from "../assets/HMT+Album+Cover.jpg";
import alistair from "../assets/BXR+Album+Cover.jpg";
import ptps from "../assets/PTPS/PTPS Album Cover.png";
import MultilinePlayer from "../components/MultilinePlayer";
import dreamFactoryCover from "../assets/DreamFactory/TDF Album Cover.png";
import btrp from "../assets/BTRP.png";
import spell from "../assets/spell.png";
import tek from "../assets/ATAS-TEKHA Album Cover.png";
import rots from "../assets/ROTS Album Cover.png";
import sprout from "../assets/Sprout.png";
import afterlife from "../assets/AFTL Album Cover.jpg";
import broadway from "../assets/BWBL Album Cover.png";
import upstream from "../assets/upstream_69.png";
import tmsmsCover from "../assets/covers/TMSMS-Album-FULL.jpg";
import rrwwCover from "../assets/covers/RRWW_Album.jpg";
import reachCover from "../assets/covers/REACH-Cover-Credits.jpg";
import sereinCover from "../assets/covers/SRN_OSTAlbum_Export.jpg";
import startCover from "../assets/covers/START-Album-Cover-Credit.jpg";
import unicornCover from "../assets/covers/TMUT-Album-Cover-Credit.jpg";
import survivorsCover from "../assets/covers/SRVR-Album-Credits.jpg";
import puddleCover from "../assets/covers/PDDL-Album-Cover-Credit.jpg";
import mixedJamsCover from "../assets/covers/BTND-Album-Cover.jpg";
import shuriken from "../assets/covers/SHSG-Album-Cover.jpg";
import claws from "../assets/covers/CLA-Album-Cover.jpg";

function Music() {

  const albums = [
    {id: "tmsms",
      img: tmsmsCover,
      file: ["https://www.dl.dropboxusercontent.com/scl/fi/s1a9bif7uo6uzqt69p58a/TMSMS-T03v1-M03-Run-Tiger-Run.wav?rlkey=p5qq6sor9218u32v068ojdpie&e=1&dl=0"],
      title: "The Moon Stole My Stripes",
      description: "Short Film / Animated Film",
      info: [{title: "The Moon Stole My Stripes"}],
    },
    {id: "rrww",
      img: rrwwCover,
      file: ["https://www.dl.dropboxusercontent.com/scl/fi/13je6siky0vogdv8f2uzu/RRWW-Preview.wav?rlkey=7nxbyyv3722fymk6oj7j2aday&e=1&dl=0"],
      title: "Roger Williams",
      description: "Video Game",
      info: [{title: "Roger Williams"}],
    },
    {id: "reach",
      img: reachCover,
      file: ["https://www.dl.dropboxusercontent.com/scl/fi/m39jnei4wrhzoae3im1k1/REACH-Preview.wav?rlkey=ctyeue4qg6c9iktjqafgt9z0h&e=1&dl=0"],
      title: "Reach",
      description: "Short Film / Animated Film",
      info: [{title: "Reach"}],
    },
    {id: "serein",
      img: sereinCover,
      file: ["https://www.dl.dropboxusercontent.com/scl/fi/5escunvcd97guznyiwjzh/SRIN-Preview.wav?rlkey=bd6wxjhhkv2trg7vgy7ol17p2&e=1&dl=0"],
      title: "Serein",
      description: "Short Film / Animated Film",
      info: [{title: "Serein"}],
    },
    {id: "start",
      img: startCover,
      file: ["https://www.dl.dropboxusercontent.com/scl/fi/vwx23go833kzaa5r50sr7/START-Preview.wav?rlkey=ipnmxyv6vili5cdr0syrkjfua&e=1&dl=0"],
      title: "Starting Line",
      description: "Short Film / Animated Film",
      info: [{title: "Starting Line"}],
    },
    {id: "upstream",
      img: upstream,
      file: ["https://www.dl.dropboxusercontent.com/scl/fi/cdf736k51yaoadk9yn7di/UPST-Preview.wav?rlkey=t83j6d454djnai9g29xhvo6h8&dl=0"],
      title: "Upstream",
      description: "Short Film / Animated Film",
      info: [{title: "Upstream"}]
    },{id: "unicorn",
      img: unicornCover,
      file: ["https://www.dl.dropboxusercontent.com/scl/fi/5a15pm173u7goc5cf6fqq/TMUT-Preview.wav?rlkey=29zo8m34icsgffky8oqv621qu&dl=0"],
      title: "The Magical Unicorn Tales",
      description: "Short Film / Animated Comedy",
      info: [{title: "The Magical Unicorn Tales"}]
    },
    {id: "survivors",
      img: survivorsCover,
      file: ["https://www.dl.dropboxusercontent.com/scl/fi/kxfn6479hrnhe69m2kinu/SRVR-T01v1-M03-Don-t-Play-With-Knives.wav?rlkey=3kjarq8okyz8wq9tgmwogbl99&dl=0"],
      title: "Survivors",
      description: "Short Film / Animated Adventure",
      info: [{title: "Survivors"}]
    },
    {id: "puddle",
      img: puddleCover,
      file: ["https://www.dl.dropboxusercontent.com/scl/fi/envddh2n73xa9b3ori35e/PDDL-Preview.wav?rlkey=ltzdqi4usbu36n1ocxye5au3n&dl=0"],
      title: "Puddle",
      description: "Short Film / Stop Motion Comedy",
      info: [{title: "Puddle"}]
    },
    {id: "mix",
      img: mixedJamsCover,
      file: ["https://www.dl.dropboxusercontent.com/scl/fi/k92b1nog2koik64w7qlpr/Day-1-Track-4-Fast-n-Easy.wav?rlkey=ax25y7qznhmt16jyse1uw4nw1&dl=0"],
      title: "Mixed Jams (from Beat Tender)",
      description: "EP / Jazz Fusion",
      info: [{title: "Mixed Jams (from Beat Tender)"}]
    },
    {
      id: "shu",
      img: shuriken,
      file: [
        "https://www.dl.dropboxusercontent.com/scl/fi/ieh8cmgjeu7qkyjhtakqw/SHSG-Preview.m4a?rlkey=ks0hneigkoottx0y1jlg1ocr8&dl=0",
      ],
      title: "Shuriken Saga",
      description: "Video Game / Japanese Adventure",
      info: [{ title: "Shuriken Saga" }],
    },
    {
      id: "cao",
      img: claws,
      file: [
        "https://dl.dropboxusercontent.com/scl/fi/llevzt3ift4z06dx1rlvq/CLA-Preview.m4a?rlkey=ae5xg5qs038rjtwhutcegqm9c&e=1&dl=0",
      ],
      title: "Claws and Order",
      description: "Short Film / Musical",
      info: [{ title: "Claws and Order" }],
    },
    {
      id: "afterlife",
      img: afterlife,
      file: [
        "https://www.dl.dropboxusercontent.com/scl/fi/dmrnwu4gskvpf655faor0/AFTL-Social-Media-Preview.m4a?rlkey=298y42zbcrfzyp6m8yd94o3ii&e=1&dl=0",
      ],
      title: "Afterlife",
      description: "Short Film / Dark Comedy",
      info: [{ title: "Afterlife" }],
    },

    // Row 2
    {
      id: "rots",
      img: rots,
      file: [
        "https://www.dl.dropboxusercontent.com/scl/fi/uifjm1bauwvldiiuy76el/ROTS-DELTA-M01v2-Delta-Emblock-s-Theme.wav?rlkey=043vo2m4p7m7y3zu2vdnemhdw&e=1&dl=0",
      ],
      title: "Resurgence of the Storm",
      description: "MOBA / Sci-Fi Fantasy",
      info: [{ title: "Resurgence of the Storm" }],
    },
    {
      id: "broadway",
      img: broadway,
      file: [
        "https://www.dl.dropboxusercontent.com/scl/fi/8smkz4cbxw9m0cp6yotql/BWBL-T01v1-S01-Like-It-s-A-Dream.wav?rlkey=bh1ibgzx5a7qznjh6w8nraz7b&dl=0",
      ],
      title: "Broadway Blues",
      description: "Short Film / Musical",
      info: [{ title: "Broadway Blues" }],
    },
    {
      id: "tekha",
      img: tek,
      file: [
        "https://www.dl.dropboxusercontent.com/scl/fi/br98cgv6sximop5zdp2ax/TEKHA-T01-Full-Character-Showcase.wav?rlkey=ui6u2947wycpqxzdzbx7909kx&dl=0",
      ],
      title: "Across The Astral Sea: Tekha",
      description: "TTRPG / Adventure Pop Punk",
      info: [{ title: "Across The Astral Sea: Tekha" }],
    },

    // Row 3
    {
      id: "sprout",
      img: sprout,
      file: [
        "https://www.dl.dropboxusercontent.com/scl/fi/jr00sb0y6il6p9vi652l0/SPRT-Social-Media-Preview.m4a?rlkey=25cydip38sch9b50sbe6gyh59&dl=0",
      ],
      title: "Sprout",
      description: "Short Film / Orchestral",
      info: [{ title: "Sprout" }],
    },
    {
      id: "dreamFactory",
      img: dreamFactoryCover,
      file: [
        "https://www.dl.dropboxusercontent.com/scl/fi/0lhty67m1z0iqkyhpkdif/TDF-Social-Media-Preview.mp3?rlkey=adqrmyod72roicfed57uxavqn&dl=0",
      ],
      title: "The Dream Factory",
      description: "Short Film / Orchestral",
      info: [{ title: "The Dream Factory" }],
    },
    {
      id: "spell",
      img: spell,
      file: [require("../assets/ASTB Preview.mp3")],
      title: "A Spell To Break",
      description: "Short Film / Magical Fantasy",
      info: [{ title: "A Spell To Break" }],
    },

    // Row 4
    {
      id: "ptps",
      img: ptps,
      file: [
        "https://www.dl.dropboxusercontent.com/scl/fo/cwxd6z2d4uef8vl24m2x5/h/_Final%20Tracks%20%28Audio%29/PTPS%20ST01v1%20M01v4%20Main%20Menu.wav?rlkey=1lk894vipypruh8cqhfknijqx&dl=0",
      ],
      title: "Potion Pushas",
      description: "Video Game / Fantasy, Noir, Electronic",
      info: [{ title: "Potion Pushas" }],
    },
    {
      id: "btrp",
      img: btrp,
      file: [
        "https://www.dl.dropboxusercontent.com/scl/fi/ml1cxf08rso7mn09565ks/ASTB-Preview.mp3?rlkey=r04jz5hhkudy8ssvyrsrfuhvz&dl=0",
      ],
      title: "Beach Trip!",
      description: "Short Film / Country Comedy",
      info: [{ title: "Beach Trip!" }],
    },
    {
      img: bard2,
      title: "A Bard’s Tale: The Plane of Elemental Chaos Vol. 1",
      description: "Library Music / Contemporary",
    },

    // Row 5
    {
      id: "stalling",
      img: stalling,
      file: [require("../assets/STL+DEMO+M10+At+Shit_s+End.mp3")],
      title: "Stalling",
      description: "Short Film / Musical Comedy",
      info: [{ title: "Stalling" }],
    },
    {
      id: "shp",
      img: shp,
      file: [require("../assets/SHP_Soundtrack_Preview_v2.mp3")],
      title: "Shpilkes",
      description: "Short Film / Psychological Thriller",
      info: [{ title: "Shpilkes" }],
    },
    {
      img: missingTwin,
      title: "Missing Twin",
      description: "Feature Film / Drama, Thriller",
    },

    // Row 6 (extras)
    {
      id: "bard1",
      img: bard1,
      file: [require("../assets/NRS+DEMO+105+Pursuit.mp3")],
      title: "A Bard’s Tale: Norse Vol. 1",
      description: "Library Music / Norse, Folk, Metal",
      info: [{ title: "A Bard’s Tale: Norse Vol. 1" }],
    },
    {
      id: "bxr",
      img: alistair,
      file: [
        "https://www.dl.dropboxusercontent.com/scl/fi/7nqm0puw0wjx25lsp4q0w/BXR-Preview.m4a?rlkey=e7q2o60nx4uvrpq8cc1y5bsol&e=1&dl=0",
      ],
      title: "Alistair",
      description: "Video Game / Horror, Electronic",
      info: [{ title: "Alistair" }],
    },
  ];

  // Below Bootstrap's lg breakpoint the three-across grid is unreadable, so the
  // albums render as one continuous column instead.
  const MOBILE_QUERY = "(max-width: 991.98px)";
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(MOBILE_QUERY).matches,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    const handleChange = (event) => setIsMobile(event.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  const colStyles = [
      { padding: "3%", paddingLeft: "8%" },
      { padding: "3%" },
      { padding: "3%", paddingRight: "8%" },
    ];
  const numCols = 3;
    const chunkSize = Math.ceil(albums.length / numCols);

    // Split into [ [first 6], [next 6], [rest 5] ]
    const columns = albums.reduce(
      (acc, album, idx) => {
        const colIndex = idx % numCols;
        acc[colIndex].push(album);
        return acc;
      },
      Array.from({ length: numCols }, () => [])
    );

  return (
    <>
      <div style={{ width: "100vw", background: "black" }}>
        <MarcNavbar />
        <br />
        <br />
        <h2
          className="hideOnMobile"
          style={{ color: "white", textAlign: "center", paddingBottom: "15px" }}
        >
          SELECT TRACKS
        </h2>
        <p
          className="hideOnMobile"
          style={{
            textAlign: "center",
            color: "white",
            fontFamily: "Georgia",
            paddingBottom: "15px",
          }}
        >
          <i>
            Interested in music for your project?{" "}
            <Link style={{ color: "grey" }} to="/contact">
              Send a message
            </Link>{" "}
            to request a custom demo reel!
          </i>
        </p>
        <Container>
          <Row>
            <div className="hideOnMobile" style={{ width: "100%" }}>
              <MultilinePlayer style={{ paddingBottom: "100px" }} />
              <hr
                style={{
                  color: "white",
                  border: "2px solid white",
                }}
              />
            </div>
            <h2
              style={{
                color: "white",
                textAlign: "center",
                paddingBottom: "15px",
                paddingTop: "15px",
              }}
            >
              ALBUMS
            </h2>

            {isMobile ? (
              <Col xs={12} style={{ padding: "3%" }}>
                {albums.map((a) => (
                  <Album
                    key={a.id ?? a.title}
                    id={a.id}
                    img={a.img}
                    file={a.file}
                    title={a.title}
                    description={a.description}
                    info={a.info}
                  />
                ))}
              </Col>
            ) : (
              columns.map((colAlbums, colIdx) => (
                <Col key={colIdx} style={colStyles[colIdx]}>
                  {colAlbums.map((a) => (
                    <Album
                      key={a.id ?? a.title}
                      id={a.id}
                      img={a.img}
                      file={a.file}
                      title={a.title}
                      description={a.description}
                      info={a.info}
                    />
                  ))}
                </Col>
              ))
            )}
          </Row>
          <div style={{ paddingTop: "5%" }}></div>
          <div
            style={{
              height: "3px",
              backgroundColor: "white",
              width: "100%",
            }}
          />
          <div style={{ paddingTop: "5%" }}></div>
          <Row>
            <Col></Col>
            <Col></Col>
          </Row>
          <br />
          <br />
          <br />
          <br />
        </Container>

        <MarcFooter />
        <br />
        <br />
        <br />
        <br />
      </div>
    </>
  );
}

export default Music;
